module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('community-members-table'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Community members actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshCommunityMembers
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n      ")]), _vm._v(" "), (_vm.loggedIn) ? _c('b-btn', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.isCommunityMember || _vm.communityApplicationStatus !== null
    },
    on: {
      "click": _vm.applyToCommunity
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.apply')) + "\n      ")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ae8ec7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityMembers.vue
// module id = 471
// module chunks = 0